import styled from "styled-components";

export const FeedbackContainer = styled.div``;
export const FeedBackHeader=styled.div`
@media(max-width:991px){
    display: flex;
    gap: 5px;
}
`
